import IPlayerData from '../Player/IPlayerData';

/**
 * Check for conflicts between two data sets
 */
export function conflicts(a: IPlayerData, b: IPlayerData) {
    return a.currencies !== b.currencies || a.level_star !== b.level_star;
}

/**
 * Get conflicting data sets in list
 */
export function getConflictingSets(dataSets: IPlayerData[]) {
    return dataSets.reduce((acc, current) => {
        // Skip null or empty objects
        if (!current || Object.keys(current).length === 0) return acc;
        // If doesn't conflict it is the same set
        const alreadyAdded = acc.some(other => !conflicts(current, other));
        if (
            !alreadyAdded &&
            dataSets.some(other => conflicts(current, other))
        ) {
            acc.push(current);
        }
        return acc;
    }, []);
}
